import * as NavTree from './nav_tree.js';
import * as NonUniqueUrls from './non_unique_urls';
import * as Breadcrumb from './breadcrumb.js';
import * as events from '../helpers/events';

const mainBreadcrumb = new Breadcrumb();
const navTree = new NavTree({
    origin: location.pathname === "/connected-app" ? "top" : navTreeStartLevel,
    startNode: navTreeStartNode,
    urlUsageLog: urlUsageLog,
    urlNavTreeInfo: urlNavTreeInfo,
    urlNavTreeInfoContent: urlNavTreeInfoContent,
    urlNavTreeConf: urlNavTreeConf,
    urlNavTreeLevel: urlNavTreeLevel,
    surveysUrl: surveysUrl
});
const nonUniqueUrls = new NonUniqueUrls();

window.getBreadcrumbInstance = function() {
    return mainBreadcrumb;
};
window.getNavigationTreeInstance = function() {
    return navTree;
};

document.addEventListener("DOMContentLoaded", function() {

    let labels = {};
    let crumbs = document.getElementById("breadcrumb").querySelectorAll("[data-level-id]");
    for (let i in crumbs) {
        if (crumbs[i].dataset) {
            labels[crumbs[i].dataset.levelId] = crumbs[i].innerHTML.trim();
        }
    }

    setTimeout(function(){
        navTree.init(labels, window.dispatcher);
        if (location.pathname === "/connected-app") {
            navTree.open();
        }

        window.dispatcher.on('nav-tree_open-level', (data) => {
            navTree.open().goto(data.id, false, true);
        });

        mainBreadcrumb.init(document.getElementById("breadcrumb"));
        mainBreadcrumb
            .click(function(levelId, elem, event) {
                if (elem.querySelector(".file-icon") || event.target.closest(".info-icon")) {

                    if (elem.classList.contains('question-crumb')) {
                        navTree.navTreeInfoModal('surveys', elem.dataset.questionId);
                        return;
                    }

                    navTree.navTreeInfoModal(levelId);
                    event.navtree = event.navtree || {};
                    event.navtree.cancelOpenNavTree = true;
                }
            })
            .click((typeof navTreeBreadcrumbClickHandler === "function" ? navTreeBreadcrumbClickHandler.bind(mainBreadcrumb, navTree) : function (levelId, elem, event) {
                if (elem.parentNode.dataset.notAllowed || elem.classList.contains('leaf-node')) {
                    return false;
                }

                if (event.navtree && event.navtree.cancelOpenNavTree) {
                    return false;
                }

                if (elem.matches("li:not(:last-child) > .crumb")) {
                    navTree.open().goto(levelId || "top");
                }
            }));
    }, 500);

    if (typeof overrideNavTreeStartLevel === "function") {
        overrideNavTreeStartLevel(navTree);
    }

    events.addEvent(document.querySelector('#header-primary .app-logo'), 'click', function(event) {
        event.preventDefault();
        event.navtree = {
            closeNavTree: false
        };
        navTree.goto('top');
    });

    nonUniqueUrls.init();
});
